
export default function() {
    function init() {
        const shareButton = document.querySelector('.share__button');
        shareButton.addEventListener('click', (e) => {
            e.preventDefault();
            if(shareButton.classList.contains('active')) {
                shareButton.classList.remove('active');
            } else {
                shareButton.classList.add('active');
            }
            
        });
    }

    if(document.querySelector('.share')) {
        init();
    }
}